<template>
  <div
    v-if="shouldShow()"
    class="cert-row"
  >
    <ul
      v-for="attachment in attachments"
      :key="attachment.id"
    >
      <li>
        <a
          :href="attachmentURL(attachment)"
          target="_blank"
        >
          {{ attachmentName(attachment) }}
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    props: {
      flashcard: {
        type: Object,
      },
    },
    data() {
      return {
        attachmentIds: {
          type: Array,
          default: [],
        },
      };
    },
    computed: {
      allGroupings() {
        return this.$store.getters['groupings/allArray'] || [];
      },
      attachments() {
        if( this.attachmentIds?.includes ) {
          const allAttachments = this.$store.getters['attachments/attachments'];
          return allAttachments.filter( attachment => this.attachmentIds.includes(attachment.id) );
        }
      },
    },
    watch: {
      flashcard(newVal, oldVal) {
        this.setFlashcards();
      },
    },
    mounted() {
      if (this.allGroupings.length > 0) {
        this.setFlashcards();
      }
    },
    methods: {
      attachmentURL(attachment) {
        return attachment.url;
      },
      attachmentName(attachment) {
        return attachment.rawName;
      },
      setFlashcards() {
        let groupings = this.allGroupings.filter( grouping => grouping.assetAssociations.map( aa => aa.assetBType == 'V3Flashcard' && aa.assetBId == this.flashcard.id ).includes(true) );
        let groups = groupings.map( g => g.assetAssociations ).flat();
        this.attachmentIds = groups.filter( g => g.assetBType == 'Attachment' ).map( g => g.assetBId );
        this.$store.dispatch('attachments/fetch', {ids: this.attachmentIds});
      },
      shouldShow() {
        return this.attachmentIds.length > 0;
      },
    },
  };
</script>

<style lang='scss'>
  .cert-row {
    margin-top: 15px;
    background: white;
    border-radius: 4px;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.25);
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: rem-calc(32);
    text-align: center;

    ul {
     list-style-type: none;
    }

    &.countdown-modal {
      background: #1669BA;
    }

    svg {
      margin: 0 auto;

      &.expired circle {
        stroke: #fd7e78 !important;
      }

      @include breakpoint(small) {
        height: rem-calc(64);
        width: rem-calc(64);
      }
    }

    .title {
      color: #12263b;
      font-size: rem-calc(20);
      font-weight: $bold;
      margin: rem-calc(20) 0;
      text-align: center;

      &.ready {
        color: white;
        font-size: rem-calc(26);
        font-weight: $semi-bold;
      }

      @include breakpoint(small) {
        font-size: rem-calc(24);
        margin-top: rem-calc(18);
      }
    }

    .text {
      color: #747E89;
      font-size: rem-calc(16);
      text-align: center;
    }

    .actions {
      display: flex;
      flex-direction: row;
      justify-content: center;
      margin-top: rem-calc(20);
      text-align: center;

      .back, .ready {
        border-radius: 4px;
        color: white;
        cursor: pointer;
        font-size: rem-calc(14);
        font-weight: $semi-bold;
        padding: rem-calc(8) rem-calc(20);
        width: rem-calc(72);


        @include breakpoint(large) {
          font-size: rem-calc(10);
        }

        @include breakpoint(small) {
          font-size: rem-calc(16);
          width: rem-calc(88);
        }
      }
    }
  }
</style>
